import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import { BrandComponent } from "./components/common/BrandComponent";

export const CURRENT_BRAND =
	process.env.CURRENT_BRAND === "default" ? null : process.env.CURRENT_BRAND;
interface AppProps {
	config: any;
}

type AppPropsReact = PropsWithChildren<AppProps>;
/**
 * This is the app component.
 */
export function App({ config, children }: AppPropsReact) {
	const [localStorageData, setLocalStorageData] = useState(null);
	const [listVisible, setListVisible] = useState(false);
	const [spinnerVisibility, setSpinnerVisibility] = useState(false);

	const getLocalStorage = () => {
		const lsData = localStorage.getItem("FAplpData");
		if (
			lsData &&
			(!localStorageData || JSON.stringify(localStorageData) != lsData)
		) {
			if (lsData) {
				const data = JSON.parse(lsData).products; /*.map((x)=>{
                        x.productImage=getImage(x.upc,true);
                        x.productImageHover=getImage(x.upc,false);
                        return x;
                    });*/
				setLocalStorageData(data);
			} else {
				setLocalStorageData(null);
			}
		}
	};

	const getImage = (id: string, isFront: boolean) => {
		const imgPath =
			config && config.imgPath
				? config.imgPath
				: "https://images.ray-ban.com/is/image/RayBan/${id}__00${frame}.png?impolicy=RB_Product_front&width=570&bgc=%23f8f8fb";
		return imgPath
			.replace("${id}", id)
			.replace("${frame}", isFront ? "1" : "2");
	};

	const handleLoadedGeneric = () => {
		setSpinnerVisibility(false);
		setTimeout(() => {
			try {
				//@ts-ignore
				let text = $(".navigation__back").text().trim();
				//@ts-ignore
				let arrowHtml = $(".navigation__back").find("div")[0].outerHTML;
				//@ts-ignore
				$(".navigation__back").html(
					arrowHtml + text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
				);
			} catch (error) {}
		}, 200);
	};

	const handleLoadedProduct = () => {
		setSpinnerVisibility(false);
	};

	const handleLoadingGeneric = () => {
		setListVisible(false);
		setSpinnerVisibility(true);
	};

	const handleLoadingGenericProduct = () => {
		setListVisible(true);
		setSpinnerVisibility(true);
	};

	useEffect(() => {
		//getLocalStorage();
		window.addEventListener("fa-storage", getLocalStorage);
		return () => window.removeEventListener("fa-storage", getLocalStorage);
	}, []);

	useEffect(() => {
		document
			.querySelector("body")
			.addEventListener("fa-loading", handleLoadingGeneric);
		return () =>
			document
				.querySelector("body")
				.removeEventListener("fa-loading", handleLoadingGeneric);
	}, []);

	useEffect(() => {
		document
			.querySelector("body")
			.addEventListener("fa-products-loading", handleLoadingGenericProduct);
		return () =>
			document
				.querySelector("body")
				.removeEventListener(
					"fa-products-loading",
					handleLoadingGenericProduct
				);
	}, []);

	useEffect(() => {
		document
			.querySelector("body")
			.addEventListener("fa-loaded", handleLoadedGeneric);
		return () =>
			document
				.querySelector("body")
				.removeEventListener("fa-loaded", handleLoadedGeneric);
	}, []);

	useEffect(() => {
		document
			.querySelector("body")
			.addEventListener("fa-products-loaded", handleLoadedProduct);
		return () =>
			document
				.querySelector("body")
				.removeEventListener("fa-products-loaded", handleLoadedProduct);
	}, []);

	return (
		<>
			<div style={!listVisible ? { display: "none" } : null}>
				<BrandComponent
					componentName="ProductList"
					parameter={{
						items: localStorageData,
						total: localStorageData ? localStorageData.length : 0,
						detailFunction: config.recoverDetail,
						imgPath: config.imgPath,
						goToPdp: config.goToPdp,
						buffer: config.buffer
					}}
				/>
			</div>
			{spinnerVisibility && <BrandComponent componentName="Loader" />}
		</>
	);
}
